const module = { name: 'concessions/desktop.app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



import { default as hearts } from 'swug-fdRequire-call:shared/utils/hearts';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as concessionsOfferCarousel } from 'swug-fdRequire-call:concessions/concessionsOfferCarousel';



import { default as participatingTheaters } from 'swug-fdRequire-call:concessions/participatingTheatersLoader';

function run() {
    checkDependencies(module.name, debugLog);
    concessionsOfferCarousel.init();
    hearts.init();
    participatingTheaters.init();
}
document.addEventListener('DOMContentLoaded', run);
export default module.exports;